import React, { Component } from 'react';
// import { Parallax } from 'react-skrollr'

import styles from  './styles.js';

class HvadEr extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
		});

		return (
			<div style={elmStyl} className='undervisning'>
				<div style={styles.flex}>
						<div style={styles.textComponent}>
							<div style={styles.textComponentInner}>
								<h1>Byg et digt - som undervisnings værktøj</h1>
								<div>
									<p>
									Et konkret og håndgribeligt værktøj til at arbejde med glæden, lysten til sproget og fortællingen på en enkel og tilgængelig måde.  De mange 1000 ord giver i sig selv en differentiering og udfordringsmulighed.  
									</p>
									<p>
									På egen hånd eller som samskabelse 1+1. Fra 4. -9. klasse. 
									</p>
									<p>
									Cut Up Digtere: William S. Burroughs, Dan Turéll, Henrik Bjelke	
									</p>
								</div>
							</div>
						</div>
						

				</div>
			</div>

		)
	}
}

export default HvadEr;









// WEBPACK FOOTER //
// ./src/components/HvadErUndervisning.js